<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div v-loading="loading">
          <div v-if="list.length" class="list">
            <EsProductView v-for="item in list" :key="item.id" :item="item" />
          </div>
          <div v-if="!list.length && !loading">
            <el-empty :description="$t('message.home.noData')"></el-empty>
          </div>
          <div class="common-pagination">
            <el-pagination
              v-if="list.length"
              background
              layout="prev, pager, next"
              :page-size="pageSize"
              :current-page="pageNum"
              :total="total"
              @current-change="currentChange"
            />
          </div>
        </div>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import EsProductView from "@/components/product";
import { recommend } from "@/api/goods/goods";

export default {
  components: { EsProductView },
  data() {
    return {
      list: [],
      loading: false,
      pageNum: 1,
      pageSize: 18,
      total: 0,
    };
  },
  mounted() {
    this.getDiscountedList();
  },
  methods: {
    getDiscountedList() {
      this.loading = true;
      recommend({ count: this.pageSize }).then(r => {
        const goods = r.data?.data?.recommendGoodss || r.data?.data?.content || [];
        this.list = goods;
        this.total = goods.length;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    currentChange(page) {
      this.pageNum = page;
      this.getDiscountedList();
    },
  },
};
</script>

<style lang="scss" scoped>
  .container-box {
    min-height: 600px;
    .list {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(228px, 190px));
      grid-column-gap: 14px;
      grid-row-gap: 20px;
      align-content: center;
      padding: 26px 0;
    }
    .common-pagination {
      width: 100%;
      text-align: center;
      padding: 40px 0;
    }
  }
</style>
